import { supabase } from "../../supabaseClient"

export const saveCostCenter = async (id = undefined, item) => {
    if (id) {
        return await supabase
            .from('CostCenter')
            .update({ ...item })
            .match({ id })
    } else {
        return await supabase
            .from('CostCenter')
            .insert([{ ...item }])
    }
}

export const loadCostCenters = async (companyId) => {
    let { data, error } = await supabase
        .from('CostCenter')
        .select('*')
        .eq("company_id", companyId)
        .is('deleted_at', null)
        .order('code', { ascending: true })
    if (!error) {
        return data
    }
    return []
}

export const deleteCostCenter = async (id, userId) => {
    return await supabase
        .from('CostCenter')
        .update({ deleted_at: new Date(), deleted_by: userId })
        .match({ id })
}
